(function () {
  // Cache-bust marker — confirm in DevTools that this file is loaded
  window.__wishlistBtnVersion = '20260810-login-notice-v3';

  // Prevent double-init when script is present on both theme.liquid and main-product.liquid
  if (window.__wishlistBtnInit) return;
  window.__wishlistBtnInit = true;

  /** @type {Set<string>|null} */
  let wishlistedIds = null;
  /** @type {Promise<Set<string>>|null} */
  let listFetchPromise = null;

  function isCustomerLoggedIn() {
    return !!(window.wishlistStrings && window.wishlistStrings.isLoggedIn);
  }

  function redirectToLogin() {
    // No toast — message is shown on the login page above the form
    try {
      sessionStorage.setItem('wishlist_login_notice', '1');
    } catch (e) {
      /* ignore */
    }
    var returnUrl = window.location.pathname + window.location.search;
    window.location.assign(
      '/account/login?wishlist_login=1&return_url=' + encodeURIComponent(returnUrl)
    );
  }

  // Event delegation — works for PDP, collection grids, and AJAX-replaced cards
  document.addEventListener('click', function (e) {
    const wishlistBtn = e.target.closest('.wishlist-btn[data-product-id]');
    if (wishlistBtn) {
      e.preventDefault();
      e.stopPropagation();
      handleToggle(wishlistBtn);
      return;
    }

    const shareBtn = e.target.closest('.share-btn--overlay');
    if (shareBtn) {
      e.preventDefault();
      e.stopPropagation();
      handleShare(shareBtn);
    }
  });

  function buttonsFor(productId) {
    const id = String(productId);
    return document.querySelectorAll('.wishlist-btn[data-product-id="' + id + '"]');
  }

  function setActive(productId, isActive) {
    buttonsFor(productId).forEach((b) => {
      b.classList.toggle('active', isActive);
      b.setAttribute('aria-pressed', String(isActive));
    });
  }

  function setLoading(productId, isLoading) {
    buttonsFor(productId).forEach((b) => {
      b.classList.toggle('is-loading', isLoading);
    });
  }

  function isAuthErrorStatus(status) {
    return status === 401 || status === 403;
  }

  function ensureWishlistIds() {
    if (!isCustomerLoggedIn()) {
      wishlistedIds = new Set();
      return Promise.resolve(wishlistedIds);
    }
    if (wishlistedIds) return Promise.resolve(wishlistedIds);
    if (!listFetchPromise) {
      listFetchPromise = fetch('/apps/wishlist/list')
        .then(async (res) => {
          if (!res.ok) {
            wishlistedIds = new Set();
            return wishlistedIds;
          }
          const data = await res.json();
          wishlistedIds = new Set((data.products || []).map((p) => String(p.id)));
          return wishlistedIds;
        })
        .catch(() => {
          wishlistedIds = new Set();
          return wishlistedIds;
        });
    }
    return listFetchPromise;
  }

  async function syncButtons() {
    const btns = document.querySelectorAll('.wishlist-btn[data-product-id]');
    if (!btns.length) return;

    const ids = await ensureWishlistIds();
    const seen = new Set();
    btns.forEach((btn) => {
      const id = String(btn.dataset.productId);
      if (seen.has(id)) return;
      seen.add(id);
      setActive(id, ids.has(id));
    });
  }

  async function handleToggle(btn) {
    const productId = String(btn.dataset.productId);
    const previousState = btn.classList.contains('active');

    // Guest: go straight to login page (message rendered there — never toast)
    if (!isCustomerLoggedIn()) {
      setActive(productId, previousState);
      redirectToLogin();
      return;
    }

    setActive(productId, !previousState);
    setLoading(productId, true);
    try {
      const res = await fetch('/apps/wishlist/toggle', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ product_id: productId }),
      });

      if (isAuthErrorStatus(res.status)) {
        setActive(productId, previousState);
        redirectToLogin();
        return;
      }

      if (!res.ok) throw new Error('Error ' + res.status);

      const data = await res.json();
      setActive(productId, data.is_wishlisted);
      if (wishlistedIds) {
        if (data.is_wishlisted) wishlistedIds.add(productId);
        else wishlistedIds.delete(productId);
      }
    } catch {
      setActive(productId, previousState);
    } finally {
      setLoading(productId, false);
    }
  }

  async function handleShare(btn) {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const ta = document.createElement('textarea');
      ta.value = url;
      ta.style.cssText = 'position:fixed;opacity:0';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    }
    btn.classList.add('copied');
    setTimeout(() => btn.classList.remove('copied'), 2000);
  }

  function nodeHasWishlistBtn(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches && node.matches('.wishlist-btn[data-product-id]')) return true;
    return !!(node.querySelector && node.querySelector('.wishlist-btn[data-product-id]'));
  }

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (nodeHasWishlistBtn(node)) {
          syncButtons();
          return;
        }
      }
    }
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
    syncButtons();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.body, { childList: true, subtree: true });
      syncButtons();
    });
  }
})();
